import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../../AppStateProvider';
import { useCompanyQuery } from '../../company/useCompanyQuery';
import { contactsApi } from '../api';

import { makeContactsCountByCountriesQueryKey } from './contactsCountByCountriesQueryKey';

export const useContactsCountByCountriesQuery = () => {
  const { companyLinkedinId, contactFilters } = useAppState();
  const { domain } = useCompanyQuery().data || {};
  const isEnabled = Boolean(domain);

  return useQuery({
    queryKey: makeContactsCountByCountriesQueryKey({ companyLinkedinId, domain, contactFilters }),
    queryFn: ({ queryKey: [, linkedinId, domain, searchText, persona, contactDetails, status] }) =>
      contactsApi.getContactsCountByCountries({
        searchText,
        persona,
        domain,
        linkedinId,
        contactDetails,
        status,
      }),
    enabled: isEnabled,
  });
};
